import { BrowserRouter,Routes, Route } from 'react-router-dom';
import './css-components/mainapp.css';
import Navbar from './navbar';
import Home from './home';
import About from './about';
import Courses from './courses';
import Contact from './contact';

function Mainapp() {
  return (
    <>
      <BrowserRouter>
          <Navbar />
      <div className="">
        <Routes>
                <Route path="/" index element={<Home />} />
                <Route path='/about' element={<About/>}/>
                <Route path='/courses' element={<Courses/>}/>
                <Route path='/contact' element={<Contact/>}/>
        </Routes>
      </div>
      </BrowserRouter>
    </>
  );
}

export default Mainapp;
